"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logic = void 0;
var color_1 = require("./color");
var firebase_1 = require("./firebase");
var generic_1 = require("./generic");
var gptText_1 = require("./gptText");
var hooks_1 = require("./hooks");
var Logic = /** @class */ (function () {
    function Logic(config, siteConfig) {
        var _this = this;
        /**
         * Makes an API call to the specified route with optional body data.
         *
         * @param {string} route - The API endpoint route.
         * @param {*} [body] - Optional body data to send with the API call.
         *
         * @returns {Promise} - A Promise that resolves with the API response data, or rejects with an error message.
         *
         * @example
         *
         * const apiResponse = await apiCall("users", { name: "John", age: 30 });
         * console.log(apiResponse); // { status: "success", data: { userId: 123, name: "John", age: 30 } }
         */
        this.apiCall = function (route, body, raw, url) { return __awaiter(_this, void 0, void 0, function () {
            var user, headers, options, apiUrl, response, data, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.fb.auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                    case 1:
                        user = _b.sent();
                        headers = {
                            Authorization: "Bearer ".concat(user),
                            "Content-Type": "application/json",
                        };
                        options = {
                            method: body ? "POST" : "GET",
                            headers: headers,
                            body: body ? JSON.stringify(body) : undefined,
                        };
                        apiUrl = url !== null && url !== void 0 ? url : this.api;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, , 8]);
                        return [4 /*yield*/, fetch("".concat(apiUrl, "/").concat(route), options)];
                    case 3:
                        response = _b.sent();
                        if (!response.ok) return [3 /*break*/, 5];
                        if (raw)
                            return [2 /*return*/, response];
                        return [4 /*yield*/, response.json()];
                    case 4:
                        data = _b.sent();
                        return [2 /*return*/, data];
                    case 5:
                        if (response.status === 403) {
                            this.auth();
                        }
                        else if (response.status === 402) {
                            this.perms();
                        }
                        else {
                            // this.other()
                            console.log(response);
                        }
                        _b.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _b.sent();
                        throw new Error(error_1.message);
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        this.zillowParse = function (text) { return __awaiter(_this, void 0, void 0, function () {
            var ots;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiCall("zillowParse", { text: text })];
                    case 1:
                        ots = _a.sent();
                        return [2 /*return*/, ots];
                }
            });
        }); };
        /**
         * Chat Gpt Text Functions
         */
        this.gptText = gptText_1.gptText;
        this.hooks = hooks_1.Hooks;
        this.color = color_1.color;
        this.generic = generic_1.Generic;
        this.user = {
            /**
             * Returns the history items for the current user or false if an error occurs.
             * @function
             * @memberof EloiseUserObject
             * @returns {Promise<HistoryItem[]|boolean>} The history items for the current user or false if an error occurs.
             */
            getHistory: function () { return __awaiter(_this, void 0, void 0, function () {
                var req;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.fb.docs.getUserDoc("/".concat(this.siteConfig.id, "/history"))];
                        case 1:
                            req = _a.sent();
                            if (req) {
                                return [2 /*return*/, req.data];
                            }
                            else {
                                return [2 /*return*/, false];
                            }
                            return [2 /*return*/];
                    }
                });
            }); },
            /**
             * Returns the user data for the current user or false if an error occurs.
             * @function
             * @memberof EloiseUserObject
             * @returns {Promise<BaseEloiseUser|boolean>} The user data for the current user or false if an error occurs.
             */
            getUser: function () { return __awaiter(_this, void 0, void 0, function () {
                var req;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.fb.docs.getUserDoc("")];
                        case 1:
                            req = _a.sent();
                            if (req) {
                                return [2 /*return*/, req.data];
                            }
                            else {
                                return [2 /*return*/, false];
                            }
                            return [2 /*return*/];
                    }
                });
            }); },
        };
        this.fb = new firebase_1.FB(config, siteConfig);
        this.siteConfig = siteConfig;
        this.api = siteConfig.api;
    }
    /**
     * Redirects User to Perms Error Screen
     */
    Logic.prototype.perms = function () {
        window.location.href = "/perms";
    };
    /**
     * Redirects User to Auth Error Screen
     */
    Logic.prototype.auth = function () {
        window.location.href = "/auth";
    };
    /**
     * Redirects User to Misc Error Screen
     */
    Logic.prototype.other = function () {
        window.location.href = "/other";
    };
    return Logic;
}());
exports.Logic = Logic;
